import { combineReducers } from 'redux';

import comments from './comments';
import reviewReasons from './reviewReasons';
import reviews, * as fromReviews from './reviews';

export default combineReducers({
  comments,
  reviews,
  reviewReasons,
});

export const selectComments = state => state.comments;
export const selectReviews = state => state.reviews;
export const selectReviewReasons = state => state.reviewReasons;

export const selectReview = (state, id) => fromReviews.selectReview(selectReviews(state), id);
